import { BrokerAgreementBorrower } from '../../../../../../../queries/brokerAgreementQueries';

/** The agreement borrower's entity and name, then TIN. */
export const BorrowerName = ({ borrower }: { borrower: BrokerAgreementBorrower }) => {
    return (
        <>
            {borrower.borrowerEntity && (
                <div>
                    <b>{borrower.borrowerEntity}</b>
                </div>
            )}
            {borrower.name && (
                <div>
                    <b>{borrower.name}</b>
                </div>
            )}
            {borrower.tin && <div>TIN: {borrower.tin}</div>}
        </>
    );
};
